import React from 'react';

export default {
  chat: {
    element: [
      <path d="M3.84128 20.2586C3.62501 20.2586 3.41295 20.1744 3.25307 20.0187C3.02165 19.7915 2.94087 19.4533 3.04438 19.147L4.53383 14.7568C4.07437 13.7218 3.84128 12.6026 3.84128 11.4228C3.84128 7.01505 7.42775 3.42857 11.8355 3.42857C16.2433 3.42857 19.8298 7.01505 19.8298 11.4228C19.8298 15.8306 16.2433 19.4171 11.8355 19.4171C10.6818 19.4171 9.56348 19.1638 8.42577 18.6454L4.12907 20.2072C4.03482 20.2417 3.93805 20.2586 3.84128 20.2586ZM11.8355 5.11157C8.35508 5.11157 5.52428 7.94238 5.52428 11.4228C5.52428 12.4638 5.74896 13.4416 6.19243 14.3285C6.29256 14.5296 6.30855 14.7627 6.23618 14.9756L5.20114 18.0269L8.18173 16.9439C8.39968 16.8631 8.63951 16.8783 8.84568 16.9818C9.87315 17.4951 10.8232 17.7341 11.8355 17.7341C15.316 17.7341 18.1468 14.9033 18.1468 11.4228C18.1468 7.94238 15.316 5.11157 11.8355 5.11157Z" />,
    ],
    viewBox: '0 0 24 24',
  },
  groups: {
    element: [
      <path d="M19.875 3H5.875C4.765 3 3.875 3.9 3.875 5V19C3.875 20.1 4.765 21 5.875 21H19.875C20.975 21 21.875 20.1 21.875 19V5C21.875 3.9 20.985 3 19.875 3ZM19.875 19H5.875V7H19.875V19ZM17.875 12H7.875V10H17.875V12ZM13.875 16H7.875V14H13.875V16Z" />,
    ],
    viewBox: '0 0 25 24',
  },
  community: {
    element: [
      <path d="M15 4V11H5.17L4.58 11.59L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z" />,
    ],
    viewBox: '0 0 24 24',
  },
};
